<template>
  <div>
    <div class="title container">
      <a @click="$router.back()"
        ><i class="el-icon-arrow-left"></i>广告主分析</a
      >
      -
      {{ admaster }}
    </div>
    <div class="box industry container">
      <h3>广告主概况</h3>
      <div class="content">
        <div class="item">
          <p class="value">{{ adData.materialNum | separateNum }}</p>
          <p class="label">素材数</p>
        </div>
        <el-divider class="divider" direction="vertical"></el-divider>
        <div class="item">
          <p class="value">{{ adData.showNum | separateNum }}</p>
          <p class="label">总展示数</p>
        </div>
        <el-divider class="divider" direction="vertical"></el-divider>
        <div class="item">
          <p class="value">
            {{ ((adData.clickRate ? adData.clickRate : 0) * 100).toFixed(2) }}%
          </p>
          <p class="label">平均点击率</p>
        </div>
        <el-divider class="divider" direction="vertical"></el-divider>
        <div class="item">
          <p class="value">{{ adData.deviceNumShow | separateNum }}</p>
          <p class="label">展示设备数</p>
        </div>
        <el-divider class="divider" direction="vertical"></el-divider>
        <div class="item">
          <p class="value">{{ adData.deviceNumClick | separateNum }}</p>
          <p class="label">点击设备数</p>
        </div>
      </div>
    </div>
    <div class="box show-time container" v-if="showTimeShow">
      <h3>时间投放趋势</h3>
      <div class="content">
        <div class="chart">
          <div id="chartShowTime" class="chart"></div>
        </div>
      </div>
    </div>
    <div class="box city-level container" v-if="cityLevelShow">
      <h3>城市等级分布</h3>
      <div class="content">
        <div class="chart">
          <div id="chartCityLevel" class="chart"></div>
        </div>
      </div>
    </div>
    <div class="box zone container" v-if="zoneShow">
      <h3>投放地域分布</h3>
      <div class="content">
        <div class="chart">
          <div id="chartZone" class="chart"></div>
        </div>
      </div>
    </div>
    <div class="main container">
      <div class="meta">
        <div>
          共筛选出{{ materialCount }}张素材
          <span v-if="!!updateTime">更新时间：{{ updateTime }}</span>
        </div>
      </div>
      <div class="list">
        <MaterialItem
          v-for="item in materialArr"
          :material="item"
          :key="item.id"
        ></MaterialItem>
      </div>
    </div>
    <div class="pager">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="8"
        layout="prev, pager, next, jumper"
        :total="totalPage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
let chinaJson = require("../assets/china.json");
import moment from "moment";
import _ from "underscore";
import MaterialItem from "../components/MaterialItem";
export default {
  name: "AdmasterDetail",
  components: { MaterialItem: MaterialItem },
  data() {
    return {
      start: "",
      end: "",
      chartShowTime: {},
      chartCityLevel: {},
      chartZone: {},
      adData: {},
      industryData: {},
      admaster: "",
      showTimeData: [],
      cityLevelData: [],
      zoneData: [],
      materialArr: [],
      totalPage: 0,
      currentPage: 1,
      materialCount: 0,
      updateTime: "",
      showTimeShow: true,
      cityLevelShow: true,
      zoneShow: true,
    };
  },
  mounted() {
    this.start = this.dateFormat(this.$route.query["start"]);
    this.end = this.dateFormat(this.$route.query["end"]);
    let name = this.$route.query["name"];
    this.admaster = name;
    this.queryAdmasterData();
    this.queryShowTimeData();
    this.queryCityLevelData();
    this.queryZoneData();
    this.search();
    this.chartShowTime = this.$echarts.init(
      document.getElementById("chartShowTime")
    );
    this.chartCityLevel = this.$echarts.init(
      document.getElementById("chartCityLevel")
    );
    this.chartZone = this.$echarts.init(document.getElementById("chartZone"));
    window.addEventListener("resize", this.resize);
  },
  methods: {
    dateFormat(timestamp) {
      if (!timestamp) {
        return "";
      }
      return moment(1000 * timestamp).format("YYYY-MM-DD");
    },
    resize() {
      this.chartShowTime.resize();
      this.chartCityLevel.resize();
      this.chartZone.resize();
    },
    gotoDetail(id) {
      let { href } = this.$router.resolve({
        path: "/ad-detail",
        query: { id: id },
      });
      window.open(href, "_blank");
    },
    queryAdmasterData() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
      });
      this.$http
        .get("/fireeye/advertiser/details/v2?advertiser=" + this.admaster)
        .then((res) => {
          let data = res.data;
          if (data.code == 1) {
            this.adData = data.data;
            this.totalPage = this.adData.materialNum;
            this.materialCount = this.adData.materialNum;
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    search() {
      let data = {
        page: this.currentPage - 1,
        cnt: 6,
        keyword: this.admaster,
        options: {
          stTime: this.start,
          edTime: this.end,
        },
      };
      this.$http.post("/fireeye/material/search", data).then((res) => {
        let data = res.data;
        if (data.code != 0) {
          data = data.data;
          if (this.currentPage * 8 > this.totalPage) {
            let n = this.totalPage - (this.currentPage - 1) * 8;
            this.materialArr = data.list.slice(0, n);
          } else {
            this.materialArr = data.list;
          }
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange() {
      this.search();
    },
    queryShowTimeData() {
      this.$http
        .get("/fireeye/advertiser/trend?advertiser=" + this.admaster)
        .then((res) => {
          let data = res.data;
          if (data.code == 1 && !!data.data && data.data.length > 0) {
            data = data.data;
            this.showTimeData = data;
            this.drawShowtimeChart();
          } else {
            this.showTimeShow = false;
          }
        });
    },
    drawShowtimeChart() {
      let xAxis = [];
      let display = [];
      let click = [];
      for (let item of this.showTimeData) {
        xAxis.push(item.day);
        display.push(item.show);
        click.push(item.click);
      }
      let series = [
        {
          name: "展示",
          type: "line",
          smooth: true,
          data: display,
          // areaStyle: {
          //   color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //     {
          //       offset: 0,
          //       color: "rgba(255, 0, 135)",
          //     },
          //     {
          //       offset: 1,
          //       color: "rgba(135, 0, 157)",
          //     },
          //   ]),
          // },
          // lineStyle: {
          //   color: "#2196F3",
          // },
        },
        {
          name: "点击",
          type: "line",
          smooth: true,
          data: click,
          // areaStyle: {},
          // lineStyle: {
          //   color: "#FF5722",
          // },
        },
      ];

      // 指定图表的配置项和数据
      var option = {
        tooltip: { show: true, trigger: "axis" },
        legend: {
          data: ["展示", "点击"],
          left: "right",
          top: "top",
        },
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: series,
      };

      this.chartShowTime.setOption(option);
    },
    queryCityLevelData() {
      this.$http
        .get(
          "/fireeye/advertiser/distribution/city?advertiser=" + this.admaster
        )
        .then((res) => {
          let data = res.data;
          if (data.code === 1 && !!data.data && !_.isEmpty(data.data)) {
            this.cityLevelData = data.data;
            this.drawCityLevelChart();
          } else {
            this.cityLevelShow = false;
          }
        });
    },
    drawCityLevelChart() {
      let xAxis = [];
      let yAxis = [];
      let all = 0;
      for (let key in this.cityLevelData) {
        all += this.cityLevelData[key];
      }
      for (let key in this.cityLevelData) {
        let value = ((this.cityLevelData[key] / all) * 100).toFixed(2);
        xAxis.push(key);
        yAxis.push(value);
      }
      // 指定图表的配置项和数据
      var option = {
        tooltip: { show: true, trigger: "axis", formatter: "{b}<br/>{c}%" },
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: yAxis,
            type: "bar",
            barWidth: "40",
            itemStyle: {
              color: "#02A7F0",
            },
          },
        ],
      };

      this.chartCityLevel.setOption(option);
    },
    queryZoneData(id) {
      this.$http
        .get(
          "/fireeye/advertiser/distribution/province?advertiser=" +
            this.admaster
        )
        .then((res) => {
          let data = res.data;
          console.log(data.data);
          if (data.code === 1 && !!data.data && !_.isEmpty(data.data)) {
            this.zoneData = data.data;
            this.drawZoneChart();
          } else {
            this.zoneShow = false;
          }
        });
    },
    drawZoneChart() {
      let all = 0;
      let max = 0;
      let source = [];
      for (let key in this.zoneData) {
        if (this.zoneData[key] > max) {
          max = this.zoneData[key];
        }
        all += this.zoneData[key];
      }
      for (let key in this.zoneData) {
        let value = ((this.zoneData[key] / all) * 100).toFixed(2);
        source.push([key, value]);
      }

      let option = {
        tooltip: { show: true, trigger: "axis", formatter: "{c}%" },
        xAxis: {
          type: "value",
          min: 0,
          max: 100,
          position: "top",
          interval: 10,
        },
        yAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
        },
        dataset: [
          { dimensions: ["name", "value"], source: source },
          {
            transform: {
              type: "sort",
              config: { dimension: "value", order: "asc" },
              print: true,
            },
          },
        ],
        series: [
          {
            type: "bar",
            datasetIndex: 1,
            encode: { x: "value", y: "name" },
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            itemStyle: {
              color: "#02A7F0",
            },
          },
        ],
      };
      this.chartZone.setOption(option);
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  padding: 0;
  text-align: left;
  margin-bottom: 30px;
  font-weight: 600;
  color: #00a2ff;
  a:hover {
    cursor: pointer;
  }
}
.industry .content {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;

  div.item {
    flex: 1;
    text-align: center;
    padding: 10px 20px;
    .label {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #757575;
      line-height: 20px;
      margin: 5px 0;
    }
    .value {
      font-size: 24px;
      font-family: DINCond-Bold, DINCond;
      font-weight: bold;
      color: #222222;
      line-height: 28px;
      margin: 5px 0;
    }
  }
  .divider {
    height: 40px;
    height: 24px;
    background: #bdbdbd;
    vertical-align: center;
  }
}
.box {
  border: 1px solid #ddd;
  border-radius: 3px;
  box-shadow: 3px 3px 5px #ddd;
  margin-bottom: 30px;
  padding: 20px;

  h3 {
    text-align: left;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #212121;
    line-height: 28px;
  }
  .value {
    color: #00a2ff;
    font-size: 20px;
    font-weight: 700;
  }
}
.chart {
  width: 100%;
  height: 500px;
}
.show-time {
  #chartShowTime {
  }
}
.main {
  margin-top: 36px;

  .meta {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    height: 60px;
    line-height: 60px;

    .sort {
      label {
        padding-right: 20px;
      }
      .el-select {
        display: inline-block;
      }
    }
  }

  .list {
    margin-right: -15px;
    display: flex;
    flex-wrap: wrap;
  }
}
.pager {
  margin: 30px 0 60px;
}
</style>